import { useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Collapse from "@mui/material/Collapse";

// Vero Software components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Page sections
import CaseStudyContent from "pages/Projects/components/ProjectTimeline/CaseStudyContent";

function ProjectTimeline({ items }) {
  const [expandedTitle, setExpandedTitle] = useState(null);

  return (
    <MKBox>
      {items.map(({ title, dateRange, description, image, caseStudy }, index) => {
        const isLast = index === items.length - 1;
        const isExpanded = expandedTitle === title;

        return (
          <MKBox key={title} display="flex">
            <MKBox display="flex" flexDirection="column" alignItems="center" width="16px" mr={3}>
              <MKBox
                sx={({ palette: { info } }) => ({
                  width: 14,
                  height: 14,
                  flexShrink: 0,
                  marginTop: "6px",
                  borderRadius: "50%",
                  backgroundColor: info.main,
                })}
              />
              {!isLast && (
                <MKBox
                  sx={({ palette: { grey } }) => ({
                    width: "2px",
                    flexGrow: 1,
                    marginTop: "4px",
                    backgroundColor: grey[300],
                  })}
                />
              )}
            </MKBox>
            <MKBox pb={isLast ? 0 : 4} flexGrow={1} display="flex" flexWrap="wrap" gap={2}>
              <MKBox flexGrow={1} minWidth="0">
                <MKTypography
                  variant="caption"
                  color="info"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  {dateRange}
                </MKTypography>
                <MKTypography variant="h6" mt={0.25} mb={1}>
                  {title}
                </MKTypography>
                <MKTypography variant="body2" color="text">
                  {description}
                </MKTypography>
                {caseStudy && (
                  <>
                    <MKBox
                      component="button"
                      type="button"
                      onClick={() => setExpandedTitle(isExpanded ? null : title)}
                      display="flex"
                      alignItems="center"
                      mt={1.5}
                      sx={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                    >
                      <MKTypography variant="button" color="info" fontWeight="bold">
                        {isExpanded ? "Show less" : "Read the case study"}
                      </MKTypography>
                      <Icon color="info" fontSize="small" sx={{ ml: 0.5 }}>
                        {isExpanded ? "expand_less" : "expand_more"}
                      </Icon>
                    </MKBox>
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                      <CaseStudyContent blocks={caseStudy} />
                    </Collapse>
                  </>
                )}
              </MKBox>
              {image && (
                <MKBox
                  component="img"
                  src={image}
                  alt={title}
                  width="96px"
                  height="96px"
                  borderRadius="lg"
                  sx={{ objectFit: "cover", flexShrink: 0 }}
                />
              )}
            </MKBox>
          </MKBox>
        );
      })}
    </MKBox>
  );
}

ProjectTimeline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      dateRange: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string,
      caseStudy: PropTypes.arrayOf(PropTypes.object),
    })
  ).isRequired,
};

export default ProjectTimeline;
